export const SET_MOBILE = 'site/SET_MOBILE'
export const TOGGLE_MENU = 'site/TOGGLE_MENU'
export const SHOW_NOTIFICATION_LOG = 'site/SHOW_NOTIFICATION_LOG'
